/* DOMU extras: hooks globales que las secciones propias esperan */
(function () {
  // 1. Cualquier botón con id SectionAtcBtn-* dispara el "agregar al carrito" del producto principal
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[id^="SectionAtcBtn-"]');
    if (!btn) return;
    var form = document.querySelector('product-form form[data-type="add-to-cart-form"]');
    if (!form) return;
    e.preventDefault();
    form.requestSubmit();
  });
  // 2. Links externos en pestaña nueva
  for (var i = 0; i < document.links.length; i++) {
    var a = document.links[i];
    if (a.hostname && a.hostname !== location.hostname) { a.target = '_blank'; a.rel = 'noreferrer noopener'; }
  }
  // 3. Anti-inspección (setting disable_inspect)
  if (document.body.classList.contains('no-inspect')) {
    window.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    document.addEventListener('keydown', function (e) {
      var k = e.key.toUpperCase();
      if (k === 'F12' || (e.ctrlKey && e.shiftKey && (k === 'I' || k === 'J' || k === 'C')) || (e.ctrlKey && k === 'U')) e.preventDefault();
    });
  }
  // 4. Botones "agregar al carrito" de secciones (tabla, antes/después, tabs): data-atc-variant
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-atc-variant]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.atcVariant, 10), quantity: 1 }] }) })
      .then(function (r) {
        btn.disabled = false;
        if (!r.ok) return;
        if (btn.dataset.atcSkip === 'true') { location.href = '/checkout'; return; }
        var drawer = document.querySelector('cart-drawer');
        if (drawer && drawer.renderContents) {
          fetch('/cart?sections=cart-drawer,cart-icon-bubble').then(function (x) { return x.json(); }).then(function (sections) { drawer.renderContents({ sections: sections }); drawer.open(); });
        } else { location.href = '/cart'; }
      });
  });
})();

/* domu-carousel: carrusel por scroll-snap con flechas, puntos, loop y autoplay.
   Lo usan icon-bar, image-slider, testimonials y slideshow-hero. */
class DomuCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.domu-carousel__track');
    this.slides = Array.from(this.track.children).filter((el) => !/^(STYLE|SCRIPT|TEMPLATE)$/.test(el.tagName));
    this.dots = this.querySelector('.domu-carousel__dots');
    if (this.slides.length < 2) { if (this.dots) this.dots.hidden = true; this.querySelectorAll('.domu-carousel__btn').forEach((b) => (b.hidden = true)); return; }
    this.loop = this.dataset.loop === 'true';
    var prev = this.querySelector('.domu-carousel__btn--prev');
    var next = this.querySelector('.domu-carousel__btn--next');
    if (prev) prev.addEventListener('click', () => this.go(-1));
    if (next) next.addEventListener('click', () => this.go(1));
    if (this.dots) {
      this.slides.forEach((_, i) => {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Ir a ' + (i + 1));
        b.addEventListener('click', () => this.scrollToIndex(i));
        this.dots.appendChild(b);
      });
    }
    this.track.addEventListener('scroll', () => { clearTimeout(this._t); this._t = setTimeout(() => this.update(), 80); }, { passive: true });
    var speed = parseFloat(this.dataset.autoplay);
    if (speed > 0) {
      this.start = () => { this.stop(); this.timer = setInterval(() => this.go(1), speed * 1000); };
      this.stop = () => clearInterval(this.timer);
      this.addEventListener('mouseenter', this.stop);
      this.addEventListener('mouseleave', this.start);
      this.addEventListener('touchstart', this.stop, { passive: true });
      this.addEventListener('touchend', this.start);
      this.start();
    }
    this.update();
  }
  disconnectedCallback() { if (this.stop) this.stop(); }
  step() { return this.slides[0].offsetWidth + (parseFloat(getComputedStyle(this.track).columnGap) || 0); }
  index() { return Math.round(this.track.scrollLeft / this.step()); }
  perView() { return Math.max(1, Math.round(this.track.clientWidth / this.step())); }
  perMove() { return parseInt(window.innerWidth < 990 ? (this.dataset.perMoveMobile || 1) : (this.dataset.perMove || 1), 10) || 1; }
  scrollToIndex(i) { this.track.scrollTo({ left: i * this.step(), behavior: 'smooth' }); }
  go(dir) {
    var max = this.slides.length - this.perView();
    var i = this.index() + dir * this.perMove();
    if (i > max) i = this.loop ? 0 : max;
    if (i < 0) i = this.loop ? max : 0;
    this.scrollToIndex(i);
  }
  update() {
    var i = this.index();
    if (this.dots) Array.from(this.dots.children).forEach((d, j) => d.classList.toggle('is-active', j === i));
    this.slides.forEach((s, j) => s.classList.toggle('is-active', j === i));
  }
}
customElements.define('domu-carousel', DomuCarousel);

/* domu-video: play/pausa, sonido y barra de progreso para los slides de video */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-video-toggle],[data-video-sound]');
  if (!btn) return;
  var video = btn.closest('.domu-video').querySelector('video');
  if (!video) return;
  if (btn.hasAttribute('data-video-toggle')) { video.paused ? video.play() : video.pause(); btn.classList.toggle('is-playing', !video.paused); }
  else { video.muted = !video.muted; btn.classList.toggle('is-muted', video.muted); }
});
document.querySelectorAll('.domu-video__timeline').forEach(function (bar) {
  var video = bar.closest('.domu-video').querySelector('video');
  if (!video) return;
  video.addEventListener('timeupdate', function () { bar.style.setProperty('--progress', (video.duration ? (video.currentTime / video.duration) * 100 : 0) + '%'); });
});

/* Timer de reserva del carrito: cuenta global, sobrevive a los re-render del drawer */
setInterval(function () {
  var el = document.querySelector('.domu-cart-timer');
  if (!el) return;
  var key = 'domuCartTimerEnd';
  var end = parseInt(sessionStorage.getItem(key) || '0', 10);
  if (!end || end < Date.now()) { end = Date.now() + (el.dataset.seconds ? parseInt(el.dataset.seconds, 10) * 1000 : parseInt(el.dataset.minutes || '10', 10) * 60000); sessionStorage.setItem(key, end); }
  var s = Math.max(0, Math.round((end - Date.now()) / 1000));
  document.querySelectorAll('.domu-cart-timer__value').forEach(function (v) { v.textContent = Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2); });
}, 1000);

/* Carrito: código de descuento y términos y condiciones (bloques del drawer) */
document.addEventListener('submit', function (e) {
  var f = e.target.closest('.domu-cart-discount');
  if (!f) return;
  e.preventDefault();
  var code = f.discount.value.trim(), msg = f.querySelector('.domu-cart-discount__msg');
  if (!code) return;
  fetch('/discount/' + encodeURIComponent(code), { redirect: 'follow' }).then(function () {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }).then(function () {
    msg.hidden = false; msg.classList.remove('is-error'); msg.textContent = 'Código guardado: se aplica en el checkout.';
    document.cookie = 'discount_code=' + encodeURIComponent(code) + ';path=/';
  }).catch(function () { msg.hidden = false; msg.classList.add('is-error'); msg.textContent = f.dataset.error; });
});
document.addEventListener('click', function (e) {
  var btn = e.target.closest('#CartDrawer-Checkout');
  if (!btn) return;
  var tnc = document.querySelector('.domu-cart-tnc');
  if (!tnc) return;
  var box = tnc.querySelector('.domu-cart-tnc__box');
  if (box && !box.checked) { e.preventDefault(); tnc.querySelector('.domu-cart-tnc__warn').hidden = false; }
});
document.addEventListener('change', function (e) {
  if (!e.target.classList.contains('domu-cart-tnc__box')) return;
  var tnc = e.target.closest('.domu-cart-tnc');
  tnc.querySelector('.domu-cart-tnc__warn').hidden = e.target.checked;
  if (tnc.dataset.disableCheckout === 'true') { var b = document.getElementById('CartDrawer-Checkout'); if (b) b.disabled = !e.target.checked; }
});
